export default __webpack_public_path__ + "static/media/hash.5a0e3e58.svg";